<ng-template #content>
  <ng-content></ng-content>
</ng-template>
@if (enableNavigation) {
  <span [capHistinfo]="histinfo">
    <a
      [ngbTooltip]="tooltip | translate: tooltipParams"
      [placement]="placement"
      [queryParams]="enrichedQueryParams"
      [routerLink]="path"
      [target]="openInNewTab ? '_blank' : '_self'"
      class="linkAsText"
      container="body">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  </span>
} @else {
  <span [capHistinfo]="histinfo">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </span>
}
